import mexico from './mx';
import brasil from './br';

export const messages = {
  mx: mexico,
  br: brasil
}

export default messages